export default __webpack_public_path__ + "static/media/icons8-painting.e3c8638b.svg";